import { listAppRecommendations } from '@wix/ambassador-funnel-app-recommendation-v1-app-recommendation/http'
import { AppRecommendation } from '@wix/ambassador-funnel-app-recommendation-v1-app-recommendation/types'
import { tryCatch } from '@wix/funnel-utils'
import type { Dispatch } from 'react'

import { ambassadorHttpClient } from '../../../../api/httpClient'
import { rateLimit } from '../../../../utils/rateLimit'
import { App, AppLevel } from '../typings/App'
import { SecondTryAction } from '../typings/SecondTryAction'
import { FALLBACK_APPS } from '../WidgetAppsMultiSelect/consts'
import { mergeAppsData } from '../WidgetAppsMultiSelect/mergeAppsData'

interface LoadRecommendedAppsParams {
  dispatch: Dispatch<SecondTryAction>
  flowBiSlug: string
  structureId: string
  industryId: string
  contentApps: App[]
  selectedAppDefIds: string[]
  minDelay: number
}

const fetchRecommendedApps = async (origin: string, structureId: string, industryId: string) => {
  if (!origin || !structureId || !industryId) {
    return FALLBACK_APPS
  }

  const request = listAppRecommendations({
    origin,
    structureId,
    industryId,
  })
  const [, response] = await tryCatch(() => ambassadorHttpClient.request(request))
  return response?.data.apps || FALLBACK_APPS
}

export const loadRecommendedApps = async ({
  dispatch,
  flowBiSlug,
  structureId,
  industryId,
  selectedAppDefIds,
  contentApps,
  minDelay,
}: LoadRecommendedAppsParams) => {
  dispatch({ type: 'loadRecommendedAppsStart' })

  const recommendedApps = await rateLimit(minDelay, async () => {
    return (await fetchRecommendedApps(flowBiSlug || '2nd_Try', structureId, industryId)) as (AppRecommendation & {
      level?: AppLevel
    })[]
  })
  const merged = mergeAppsData(recommendedApps, contentApps)
  const preselected = merged
    .filter(app => app.level === 'built-in' || app.level === 'preferred' || selectedAppDefIds.includes(app.appDefId))
    .map(app => app.appDefId)

  dispatch({ type: 'setSelectedAppDefIds', appDefIds: preselected })
  dispatch({ type: 'loadRecommendedAppsSuccess', apps: merged })
}
